import { render } from "./Audio.vue?vue&type=template&id=3d4e2f8f&ts=true&lang=pug"
import script from "./Audio.vue?vue&type=script&lang=ts"
export * from "./Audio.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/olimago/Documents/www/escape-if-you-can-01/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__